import React from 'react'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import useOnMouseAndScroll from '@shared/hooks/useOnMouseAndScroll'
import useStatus from '@shared-submodule/sm-hooks/useStatus'
// import InfoList from '@shared/components/fantasyTips/infoList'
import fantasyStyles from './style.module.scss'
import InfoList from '@shared/components/infoList'

const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })
const MatchInfo = dynamic(() => import('../matchInfo'), {
  loading: () => (
    <div className="bg-white rounded p-3">
      {Array.from(Array(5)).map((e, i) => {
        return (
          <React.Fragment key={i}>
            <div className="d-flex">
              <Skeleton width={'10%'} className={'me-3'} />
              <Skeleton width={'25%'} />
            </div>
            <hr />
          </React.Fragment>
        )
      })}
    </div>
  )
})
// const InfoList = dynamic(() => import('../../fantasyTips/infoList'))
const MatchXI = dynamic(() => import('../matchXI'))
const TeamForm = dynamic(() => import('@shared/components/match/teamForm'))
const HeadToHead = dynamic(() => import('@shared/components/match/headToHead'))
const Upcoming = dynamic(() => import('@shared/components/match/matchHeader/upcoming'))
const SpinPaceWideget = dynamic(() => import('@shared/components/venueWidget/spinPace'))
const RecentMatchesVenue = dynamic(() => import('@shared/components/venueWidget/recentMatchesVenue'))
const VenueStats = dynamic(() => import('@shared/components/venueWidget/venueStats'))

const MatchDetailOverview = ({
  data,
  matchDetail,
  teamAFormInput,
  headToHeadData,
  teamBFormInput,
  paceSpin,
  recentMatches,
  venueStats
}) => {
  const { sStatusStr } = useStatus(matchDetail)
  const { isLoaded } = useOnMouseAndScroll()
  return (
    <>
      <Row className="mb-1">
        <Col md={6}>
          <MatchInfo data={matchDetail} />
        </Col>
        <Col md={6} className="d-none d-md-block">
          <Upcoming data={matchDetail} />
        </Col>
      </Row>
      {(matchDetail?.oWeatherInfo?.sTemperature ||
        matchDetail?.oWeatherInfo?.sWeatherDescription ||
        matchDetail?.oPitchInformation?.sPitchCondition ||
        matchDetail?.oPitchInformation?.sBattingCondition) && (
        <InfoList
          fantasystyles={fantasyStyles}
          overViewData={matchDetail?.oOverview}
          overviewWeather={matchDetail?.oWeatherInfo}
          overviewPitch={matchDetail?.oPitchInformation}
        />
      )}
      {/*
      // not needed as of now SBZ-1164
      {(data && (data?.oWinnerTeam !== null ||
        data?.sAvgScore !== null ||
        data?.sPitchCondition !== null ||
        data?.sWeatherReport)) &&
        <div className="pt-0">
          <InfoList overViewData={data} />
        </div>
      } */}
      {
        ((teamAFormInput && teamAFormInput?.length > 0) || (teamBFormInput && teamBFormInput?.length > 0)) && (
          <TeamForm teamA={teamAFormInput} teamB={teamBFormInput} matchDetail={matchDetail} />
        )
      }
      {
        (((teamBFormInput || teamAFormInput) && isLoaded) || (teamBFormInput?.length === 0 || teamAFormInput?.length === 0)) && headToHeadData && headToHeadData?.length > 0 && (
          <HeadToHead data={headToHeadData} matchDetail={matchDetail} />
        )
      }
      {
        ((teamBFormInput?.length === 0 && teamAFormInput?.length === 0 && headToHeadData?.length === 0) || ((teamAFormInput?.length > 0 || teamBFormInput?.length > 0 || headToHeadData?.length > 0) && isLoaded)) && data && (data?.oTeam1?.aPlayers.length !== 0 || data?.oTeam2?.aPlayers.length !== 0) &&
        <MatchXI squadsData={data} status={sStatusStr} matchId={matchDetail?._id} />
      }
      {venueStats?.aStatsPerInning?.length > 0 && (
        <VenueStats data={venueStats} />
      )}
      {paceSpin?.nWicketsPace && paceSpin?.nWicketsSpin && (
        <SpinPaceWideget data={paceSpin} />
      )}
      {recentMatches?.aPreviousMatches?.length > 0 && (
        <RecentMatchesVenue data={recentMatches} />
      )}

    </>
  )
}

MatchDetailOverview.propTypes = {
  data: PropTypes.object,
  headToHeadData: PropTypes.array,
  infoData: PropTypes.object,
  paceSpin: PropTypes.array,
  recentMatches: PropTypes.array,
  venueStats: PropTypes.array,
  matchDetail: PropTypes.object,
  teamAFormInput: PropTypes.array,
  teamBFormInput: PropTypes.array
}

export default MatchDetailOverview
